module.exports = __webpack_public_path__ + "./fonts/logo.e28e504380cfa03b60a478d320b686ae.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/logo.svg
// module id = ./client/src/assets/img/logo.svg
// module chunks = 0